import { __awaiter, __decorate, __generator } from "tslib";
import { injectable } from 'tsyringe';
import { ServiceType } from '@gn-audio/core/api/product-catalogue/enums/service-type';
import { fetchSiteFeatures } from '@gn-audio/core/api/site-settings/fetch-site-features';
import { getProductItemServiceMetadata } from '../../utilities/get-basket-product-item-service-metadata';
import { getBasketTotalCount } from '../../utilities/get-basket-total-count';
import { BasketGiftWrappingItemComponent } from './components';
var BasketGiftWrappingPlugin = /** @class */ (function () {
    function BasketGiftWrappingPlugin() {
        var _this = this;
        this.giftWrappingItems = [];
        this.reactOnChanges = function (state) { return __awaiter(_this, void 0, void 0, function () {
            var totalCount;
            var _this = this;
            return __generator(this, function (_a) {
                this.giftWrappingItems.length = 0;
                totalCount = getBasketTotalCount(state);
                if (totalCount === 0) {
                    this.giftWrappingItems.forEach(function (x) { x.destroy(); });
                }
                else if (!!state.product_items) {
                    state.product_items
                        .forEach(function (productItem) { return __awaiter(_this, void 0, void 0, function () {
                        var _a, serviceData, shouldServiceItemBeDisplayed, isService, component, productItemId;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, getProductItemServiceMetadata(productItem, state.product_items, ServiceType.GiftWrapping)];
                                case 1:
                                    _a = _b.sent(), serviceData = _a.serviceData, shouldServiceItemBeDisplayed = _a.shouldServiceItemBeDisplayed, isService = _a.isService;
                                    if (shouldServiceItemBeDisplayed) {
                                        component = new BasketGiftWrappingItemComponent();
                                        productItemId = isService ? productItem.c_serviceMasterID : productItem.item_id;
                                        component.render({
                                            container: this.container.querySelector("[data-item-id=\"".concat(productItemId, "\"]")),
                                            data: serviceData,
                                            eventBus: this.eventBus,
                                            translations: this.translations,
                                        });
                                        this.giftWrappingItems.push(component);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                return [2 /*return*/];
            });
        }); };
    }
    BasketGiftWrappingPlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus, state = _a.state, translations = _a.translations;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.translations = translations;
                        this.container = document.querySelector(".basket-ui__content" /* BasketUIElementSelector.BasketContent */);
                        this.eventBus = eventBus;
                        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
                        return [4 /*yield*/, this.reactOnChanges(state)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketGiftWrappingPlugin.prototype.shouldRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isGiftWrappingOn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchSiteFeatures(["SfccBasketGiftWrapping" /* SiteFeature.SfccBasketGiftWrapping */])];
                    case 1:
                        isGiftWrappingOn = _a.sent();
                        return [2 /*return*/, isGiftWrappingOn.length > 0 && !!isGiftWrappingOn[0].value];
                }
            });
        });
    };
    BasketGiftWrappingPlugin.prototype.unregister = function () {
        this.eventBus.unsubscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
        this.giftWrappingItems.forEach(function (x) { x.destroy(); });
    };
    BasketGiftWrappingPlugin = __decorate([
        injectable()
    ], BasketGiftWrappingPlugin);
    return BasketGiftWrappingPlugin;
}());
export { BasketGiftWrappingPlugin };
